// cxm-admin-web/src/container/label-template-management/components/addTemplate.js

import React, { useEffect, useState } from 'react';
import { Button, Input, Select, Checkbox, InputNumber, message } from 'antd-v5';
import Preview, { printScale } from './preview';
import { requestTagTemplateAdd, requestTagTemplateUpdate } from '../../../state/request/tag';

const { Option } = Select;

const widthOptions = [
  { label: '60', value: 60 },
  { label: '80', value: 80 },
];

const heightOptions = [
  { label: '40', value: 40 },
  { label: '50', value: 50 },
  { label: '80', value: 80 },
];

// 字段配置初始数据
const defaultFields = [
  {
    fixed: false,
    isBold: true,
    key: 'buyerName',
    maxLine: 1,
    size: 3,
    title: '买家:',
    x: 20,
    y: 10,
    align: 'left',
    label: '买家名称',
    show: true,
    showTitle: false,
    disabled: true,
  },
  {
    fixed: false,
    isBold: false,
    key: 'buyerRemark',
    maxLine: 1,
    size: 1,
    title: '买家备注:',
    x: 20,
    y: 0,
    align: 'left',
    label: '买家备注',
    show: false,
    showTitle: true,
    disabled: false,
  },
  {
    fixed: false,
    isBold: false,
    key: 'dateTime',
    maxLine: 1,
    size: 1,
    title: '日期:',
    x: 20,
    y: 0,
    align: 'left',
    label: '日期',
    show: false,
    showTitle: true,
    disabled: false,
  },
  {
    fixed: false,
    isBold: false,
    key: 'line',
    maxLine: 1,
    size: 2,
    title: '',
    x: 20,
    y: 78,
    align: 'left',
    label: '分割线',
    show: true,
    showTitle: false,
    disabled: true,
  },
  {
    fixed: false,
    isBold: true,
    key: 'productName',
    maxLine: 1,
    size: 3,
    title: '货品:',
    x: 20,
    y: 96,
    align: 'left',
    label: '货品',
    show: true,
    showTitle: false,
    disabled: true,
  },
  {
    fixed: false,
    isBold: true,
    key: 'saleNumber',
    maxLine: 1,
    size: 2,
    title: '数量',
    x: 20,
    y: 0,
    align: 'left',
    label: '数量',
    show: false,
    showTitle: true,
    disabled: false,
  },
  {
    fixed: false,
    isBold: true,
    key: 'saleWeight',
    maxLine: 1,
    size: 2,
    title: '重量',
    x: 20,
    y: 0,
    align: 'left',
    label: '重量',
    show: false,
    showTitle: true,
    disabled: false,
  },
  {
    fixed: false,
    isBold: false,
    key: 'goodsRemark',
    maxLine: 2,
    size: 1,
    title: '备注:',
    x: 20,
    y: 0,
    align: 'left',
    label: '单品备注',
    show: false,
    showTitle: true,
    disabled: false,
  },
  {
    fixed: true,
    isBold: false,
    key: 'adContent',
    maxLine: 1,
    size: 1,
    title: '',
    x: 20,
    y: 288,
    align: 'center',
    label: '广告',
    show: true,
    showTitle: false,
    disabled: false,
  },
];

const fontSizeOptions = [
  { label: '小', value: 1 },
  { label: '中', value: 2 },
  { label: '大', value: 3 },
  { label: '特大', value: 4 },
  { label: '超大', value: 6 },
];

const AddTemplate = (props) => {
  const { editData = {} } = props;
  const templateDetail = (() => {
    try {
      return editData.templateDetail ? JSON.parse(editData.templateDetail) : {};
    } catch (error) {
      console.error('模板配置解析失败:', error);
      return {};
    }
  })();

  // 表单状态
  const [loading, setLoading] = useState(false);
  const [templateName, setTemplateName] = useState(editData.templateName || '');
  const [remark, setRemark] = useState(editData.remark || '');
  const [pageWidth, setPageWidth] = useState(templateDetail.pageWidth || 60);
  const [pageHeight, setPageHeight] = useState(templateDetail.pageHeight || 40);
  const [fields, setFields] = useState(
    templateDetail.fields
      ? defaultFields.map((item) => {
          const field = templateDetail.fields.find((f) => f.key === item.key);
          return {
            ...item,
            ...field,
            show: !!field,
            title: item?.title || '',
            disabled: item.disabled,
          };
        })
      : defaultFields.map((item) => ({ ...item })), // 深拷贝defaultFields
  );
  const [weightAlone, setWeightAlone] = useState(
    templateDetail.fields
      ? templateDetail.fields.find((f) => f.key === 'saleWeight')?.x === 20
      : false,
  );
  const [showMasterBuyerName, setShowMasterBuyerName] = useState(
    templateDetail.showMasterBuyerName ?? true,
  );

  // 字段位置更新回调函数
  const handleFieldPositionChange = (fieldKey, property, value) => {
    const newFields = fields.map((f) => (f.key === fieldKey ? { ...f, [property]: value } : f));
    if (fieldKey === 'saleNumber' && !weightAlone) {
      newFields.find((f) => f.key === 'saleWeight').y = value;
    }
    if (fieldKey === 'saleWeight' && !weightAlone) {
      newFields.find((f) => f.key === 'saleNumber').y = value;
    }
    setFields(newFields);
  };

  useEffect(() => {
    const saleNumberField = fields.find((f) => f.key === 'saleNumber');
    const saleWeightField = fields.find((f) => f.key === 'saleWeight');
    if (saleWeightField) {
      if (weightAlone) {
        saleWeightField.x = 20;
      } else {
        saleWeightField.x = (pageWidth * printScale) / 2;
        saleWeightField.y = saleNumberField.y;
      }
      setFields([...fields]);
    }
  }, [pageWidth, weightAlone]);
  useEffect(() => {
    const lineField = fields.find((f) => f.key === 'line');
    if (lineField) {
      if (pageWidth === 60) {
        lineField.size = 2;
      } else if (pageWidth === 80) {
        lineField.size = 4;
      }
      setFields([...fields]);
    }
  }, [pageWidth]);

  // 字段变更
  const handleFieldChange = (index, key, value) => {
    const newFields = [...fields];
    newFields[index][key] = value;
    if (newFields[index].key === 'saleNumber' && !weightAlone) {
      newFields.find((f) => f.key === 'saleWeight').y = newFields[index].y;
    }
    setFields(newFields);
  };

  // 保存
  const handleSave = async () => {
    if (!templateName) {
      message.error('请输入模板名称');
      return;
    }
    setLoading(true);
    // 这里可以做表单校验和提交
    // 示例：console.log({ templateName, remark, width, height, fields, weightAlone });
    const params = {
      templateName,
      remark,
      templateDetail: JSON.stringify({
        pageWidth,
        pageHeight,
        fields: fields.filter((f) => f.show),
        showMasterBuyerName,
      }),
    };
    if (editData.id) {
      params.templateId = editData.id;
    }
    const API = editData.id ? requestTagTemplateUpdate : requestTagTemplateAdd;
    const res = await API(params);
    setLoading(false);
    if (res.code === 200) {
      message.success('保存成功');
      props.onSaveSuccess();
    }
  };

  // 字段列表渲染（保持原有样式）
  const renderFieldList = () => (
    <div style={{ marginBottom: 24 }}>
      <div style={{ fontWeight: 'bold', marginBottom: 12 }}>字段元素</div>
      <div style={{ display: 'flex', fontWeight: 'bold', marginBottom: 8 }}>
        <div style={{ width: 90 }}>字段</div>
        <div style={{ width: 80 }}>是否显示</div>
        <div style={{ width: 80 }}>字体大小</div>
        <div style={{ width: 80 }}>是否加粗</div>
        <div style={{ width: 100 }}>是否显示标题</div>
        <div style={{ width: 80 }}>纵坐标</div>
      </div>
      {fields.map((field, idx) => (
        <div
          key={field.key}
          style={{ display: 'flex', alignItems: 'center', marginBottom: 8, height: 32 }}
        >
          <div style={{ width: 90 }}>{field.label}</div>
          <div style={{ width: 80 }}>
            <Checkbox
              checked={field.show}
              onChange={(e) => handleFieldChange(idx, 'show', e.target.checked)}
              disabled={field.disabled}
            />
          </div>
          <div style={{ width: 80 }}>
            {field.show && field.key !== 'line' && (
              <Select
                value={field.size}
                onChange={(val) => handleFieldChange(idx, 'size', val)}
                style={{ width: 60 }}
              >
                {fontSizeOptions.map((opt) => (
                  <Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
            )}
          </div>
          <div style={{ width: 80 }}>
            {field.show && field.key !== 'line' && (
              <Checkbox
                checked={field.isBold}
                onChange={(e) => handleFieldChange(idx, 'isBold', e.target.checked)}
              />
            )}
          </div>
          <div style={{ width: 100 }}>
            {field.show && field.title && (
              <Checkbox
                checked={field.showTitle}
                onChange={(e) => handleFieldChange(idx, 'showTitle', e.target.checked)}
              />
            )}
          </div>
          <div style={{ width: 80 }}>
            {field.show && (
              <InputNumber
                max={pageHeight * printScale}
                min={0}
                precision={0}
                value={field.y}
                onChange={(e) => handleFieldChange(idx, 'y', e)}
                placeholder=''
                style={{ width: 60 }}
                disabled={field.key === 'saleWeight' && !weightAlone}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div style={{ background: '#fff', borderRadius: 8, display: 'flex' }}>
      <div style={{ width: 500 }}>
        {/* 基础属性 */}
        <div style={{ marginBottom: 12, paddingRight: 18 }}>
          <div style={{ fontWeight: 'bold', marginBottom: 12 }}>基础属性</div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
            <div style={{ width: 80 }}>模板名称：</div>
            <Input
              showCount
              maxLength={30}
              value={templateName}
              onChange={(e) => setTemplateName(e.target.value)}
              placeholder='请输入模板名称'
              style={{ flex: 1 }}
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 36 }}>
            <div style={{ width: 80 }}>备注：</div>
            <Input.TextArea
              showCount
              maxLength={80}
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              placeholder='备注不显示给用户，仅用于公司内部区分模板'
              style={{ flex: 1 }}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ width: 80 }}>标签宽度：</div>
              <Select value={pageWidth} onChange={(val) => setPageWidth(val)} style={{ width: 80 }}>
                {widthOptions.map((opt) => (
                  <Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
              <span>mm</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ width: 80 }}>标签高度：</div>
              <Select
                value={pageHeight}
                onChange={(val) => setPageHeight(val)}
                style={{ width: 80 }}
              >
                {heightOptions.map((opt) => (
                  <Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
              <span>mm</span>
            </div>
          </div>
        </div>

        {/* 字段元素 */}
        {renderFieldList()}

        {/* 其他设置 */}
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontWeight: 'bold', marginBottom: 12 }}>其他设置</div>
          <Checkbox checked={weightAlone} onChange={(e) => setWeightAlone(e.target.checked)}>
            重量单独成行
          </Checkbox>
          <Checkbox
            checked={showMasterBuyerName}
            onChange={(e) => setShowMasterBuyerName(e.target.checked)}
            style={{ marginLeft: 24 }}
          >
            显示关联买家
          </Checkbox>
        </div>

        {/* 保存按钮 */}
        <div style={{ textAlign: 'center' }}>
          <Button
            loading={loading}
            type='primary'
            size='large'
            onClick={handleSave}
            style={{ width: 320 }}
          >
            保存
          </Button>
        </div>
      </div>

      {/* 右侧可拖拽预览区域 */}
      <div
        style={{
          flex: 1,
          background: '#f0f0f0',
          paddingTop: 24,
          paddingLeft: 20,
          paddingRight: 20,
        }}
      >
        <div style={{ marginBottom: '12px', textAlign: 'center' }}>
          <div style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '4px' }}>拖拽预览</div>
          <div style={{ fontSize: '12px', color: '#666' }}>
            直接拖拽字段调整位置，修改左侧属性实时更新
          </div>
        </div>

        <Preview
          pageWidth={pageWidth}
          pageHeight={pageHeight}
          fields={fields}
          showMasterBuyerName={showMasterBuyerName}
          draggable={true}
          onFieldChange={handleFieldPositionChange}
        />
      </div>
    </div>
  );
};

export default AddTemplate;
